export const HLS_EXTENSION = ".m3u8";
